<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <help :text="$t('help.invites')" :title="$t('help.invites_title')"/>

    <filters
      class="white-container"
      v-if="filters"
      :inputs="filters"
      @filter="filter"
      :extended="true"
      :loading="loading"
    >
    </filters>

    <div class="position-relative">

      <loader v-if="loading"/>

      <v-server-table
        ref="appTable"
        name="invitesTable"
        url="/admin/invites"
        :columns="columns"
        :options="options"
        @loaded="loading = false"
        @loading="loading = true"
        class="white-container">

        <template slot="beforeFilter">
          <b-row>
            <b-col>
              <router-link to="invites/create">
                <b-button
                  class="px-4">
                  {{$t('invite.add')}}
                </b-button>
              </router-link>
            </b-col>
          </b-row>
        </template>

        <template slot="id" slot-scope="props">
          <router-link :to="{path: `/invites/edit/${props.row.id}`, params: props.row}" target="_blank">
            {{ props.row.id }}
          </router-link>
        </template>

        <template slot="beforeLimit" v-if="totalRecordsCount > 10">
          {{$t('global.showing')}}&nbsp;
        </template>
        <template slot="afterLimit" v-if="totalRecordsCount > 10">
          &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
        </template>

        <template slot="code" slot-scope="props">
          <b-input-group class="w-75 d-flex flex-nowrap">
            <b-form-input
              class="rounded-left"
              readonly
              v-model="props.row.code"></b-form-input>
            <b-btn
              :id="`copyButton-${props.row.code}`"
              @click="copyDataToClipboard(props.row.code, true)"
              variant="light"
              size="sm"
              class="input-height rounded-right">
              <i class="far fa-copy fa-2x text-muted"></i>
            </b-btn>
          </b-input-group>
          <b-tooltip
            :target="`copyButton-${props.row.code}`"
            triggers="focus"
            :title="$t('invite.invite_code_copied')"
            placement="topright"
            :delay="{show: 0, hide: 800}"
          ></b-tooltip>
        </template>

        <template slot="invite_link" slot-scope="props" >
          <div class="invite-column">
            <b-input-group class="w-65 d-flex flex-nowrap">
              <b-form-input
                      class="rounded-left"
                      readonly
                      :id="`copyButton-input-${props.row.code}`"
                      :value="inviteCodeFullURL(props.row.code)"></b-form-input>
              <b-btn  :id="`copyButton-link-${props.row.code}`"
                      @click="copyDataToClipboard(props.row.code)"
                      variant="light"
                      size="sm"
                      class="input-height rounded-right">
                <i class="far fa-copy fa-2x text-muted"></i>
              </b-btn>
            </b-input-group>

            <div class="tooltip full-width-tooltip bs-tooltip-top">
              <div class="arrow"></div>
              <div class="tooltip-inner">{{inviteCodeFullURL(props.row.code)}}</div>
            </div>

            <b-tooltip
                    :target="`copyButton-link-${props.row.code}`"
                    triggers="focus"
                    :title="$t('invite.invite_copied')"
                    placement="topright"
                    :delay="{show: 0, hide: 800}"
            ></b-tooltip>
          </div>
        </template>

        <template slot="used" slot-scope="props">
          <column-check :row="props.row" column="used"/>
        </template>

        <template slot="activations" slot-scope="props">
          <router-link :to="{path: '/invites/users/' + props.row.id, props: {promo: 'test'}}"
                       v-if="props.row.activations > 0">{{props.row.activations}}</router-link>
          <span v-else>{{props.row.count_uses}}</span>
        </template>

        <template slot="actions" slot-scope="props">
          <column-action
            :deleteUrl="`/invites/${props.row.id}`"
            :route="{path: `/invites/edit/${props.row.id}`, params: {id: props.row.id}}"
            @deleteItems="refreshTable('appTable')"/>
        </template>

      </v-server-table>
    </div>
  </div>
</template>
<script>
  import axios from "@/utils/axios";
  import i18n from "@/utils/i18n";
  import {Event} from "vue-tables-2";
  import invitesFilters from './invitesFilters.js';
  import filters from '@/components/global/filters';
  import {inviteMethods} from '@/mixins/invite';

  export default {
    middleware: "auth",
    name: "Invites",
    components: {filters},
    data: () => {
      return {
        loading: false,
        totalRecordsCount: null,
        params: {
          page: 1,
          filter: {}
        },
        columns: ["id", "title", "code", "invite_link", "used", "activations", "actions"],
        filters: invitesFilters,
        options: {
          skin: [],
          headings: {
            id: "#",
            title: i18n.t('form.title'),
            code: i18n.t('form.code'),
            used: i18n.t('form.used'),
            activations: i18n.t('form.uses'),
            actions: i18n.t('button.edit'),
            invite_link: i18n.t('form.invite_link')
          },
          columnsClasses: {
            code: 'w-35',
            invite_link: 'w-25'
          },
          sortable: [],
          filterByColumn: false,
          columnsDropdown: false,
          customFilters: ["custom"],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: function (data) {
            localStorage.setItem('perPage', data.limit);
            return axios.get(this.url, {
              params: {
                limit: data.limit,
                filter: data.custom,
                page: data.page
              }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch("error", e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data.data.items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mixins: [inviteMethods],
    mounted() {
      Event.$on('vue-tables.invitesTable.loaded', ({data}) => {
        this.totalRecordsCount = data.paginator.total_items
      });
    },
    methods: {
      filter(params) {
        this.params = params;
        Event.$emit('vue-tables.invitesTable.filter::custom', params)
      }
    },
    destroyed() {
      Event.$off('vue-tables.invitesTable.loaded');
    }
  }
</script>